<div class="contents-area" (dragstart)="onDragstartBody($event)">
  <div class="block-column">
    <div>
      <h1>ログイン画面お知らせ</h1>
      <app-text-area class="app-textarea" id="INFO1" #INFO1 [subid]="'INFO1'" [(ngModel)]="kymw9300Model.loginInformation"
        [maxChars]="1200" [displayCountField]="false" [forcedEnabledMode]="" [tabindex]="0"
        [restrict]="'[ -￮\n\r]'">
      </app-text-area>
    </div>

    <div>
      <h1>トップ画面お知らせ</h1>
      <app-text-area class="app-textarea" id="INFO2" #INFO2 [subid]="'INFO2'" [(ngModel)]="kymw9300Model.topInformation"
        [maxChars]="1200" [displayCountField]="false" [forcedEnabledMode]="" [tabindex]="0"
        [restrict]="'[ -￮\n\r]'">
      </app-text-area>
    </div>
  </div>
</div>

<footer class="footer-buttons">
  <button class="btn-primary" id="btn_Update" #btn_Update (click)="eventUpdate_CLICKHandler()" forcedEnabledMode=""
    [tabindex]="0">設定</button>
</footer>
